import instance from '../instance';

const getLiveDocument = () => instance.driver.getLiveDocument();

export default getLiveDocument;
